<section class="background-color-white" *ngIf="haveHotels">
    <h1 [innerHTML]="'booking.hotelsList.title' | translate"></h1>
    <p [innerHTML]="'booking.hotelsList.intro' | translate"></p>
    <div class="hotels-wrapper">
        <ng-container *ngFor="let event of events">
            <da-hotel *ngIf="event.location && event.location.hotels && event.location.hotels.length > 0" [event]="event"></da-hotel>
        </ng-container>
    </div>
</section>
